import { all, takeLatest } from 'redux-saga/effects';

import { treeTradeActions } from '../index';
import getTreeTrade from './getTreeTrade';

const treeTradeSagas = all([
  takeLatest(treeTradeActions.getTreeTradeRequest, getTreeTrade),
]);

export default treeTradeSagas;
